import * as React from "react";
import Container from "@mui/material/Container";
import { Typography } from "@mui/material";

function PrivacyPolicy() {
  return (
    <Container className="accessibility" maxWidth="xl">
      <div className="accessibility-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            About Us
          </Typography>

          <Typography className="text">
            We are <strong>Manchester Psych Fest</strong>, a Manchester based
            music & arts festival company specialising in live music and club
            nights.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            The Personal Data We May Collect From You Includes…
          </Typography>

          <ul>
            <li>
              <Typography className="text">
                Your email address if you contact us through our websites or by
                email, or subscribe to our mailing list.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Additional data such as your phone number or your address if you
                include them when you contact us.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Your subscription preferences when you sign up to the mailing
                list of our associated venues. (*)
              </Typography>
            </li>
            <li>
              <Typography className="text">
                How you interact with our emails from the mailing lists, for
                example whether you open them and which links you click on.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Google Analytics demographic data such as gender, location,
                which browsers you use or desktop vs mobile use.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Any questions or feedback you contact us with.
              </Typography>
            </li>
          </ul>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            We Collect Your Data To…
          </Typography>

          <ul>
            <li>
              <Typography className="text">
                Send emails to you if you request a subscription to our mailing
                list.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Improve our affiliated web sites by monitoring how you use them.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Send relevant targeted advertising related to associated
                artists, our venues, associated festivals and other content we
                think will be of interest to you.
              </Typography>
            </li>
          </ul>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            We Will Not…
          </Typography>

          <ul>
            <li>
              <Typography className="text">
                Sell or rent your data to third parties.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Share your data with third parties for marketing purposes.
              </Typography>
            </li>
          </ul>

          <Typography className="text">
            We will share your data if we are required to do so by law – for
            example, by court order, or to prevent fraud or other crime.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Personal Information Retention Period…
          </Typography>

          <Typography className="text">
            We will only use and store information for as long as it is required
            for the purposes it was collected for. We will retain Personal
            Information for the period necessary to fulfil the purposes outlined
            in this Privacy Statement, unless a longer retention period is
            required or permitted by law.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Cookies
          </Typography>

          <Typography className="text">
            This site uses cookies – small text files that are placed on your
            machine to help the site provide a better user experience. In
            general, cookies are used to retain user preferences, store
            information for things like shopping carts, and provide anonymised
            tracking data to third party applications like Google Analytics.
          </Typography>

          <Typography className="text">
            As a rule, cookies will make your browsing experience better.
            However, you may prefer to disable cookies on this site and on
            others. The most effective way to do this is to disable cookies in
            your browser. We suggest consulting the Help section of your browser
            or taking a look at{" "}
            <a
              href="http://www.aboutcookies.org/"
              target="_blank"
              rel="noreferrer"
            >
              the About Cookies website
            </a>{" "}
            which offers guidance for all modern browsers.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            You Have The Right To…
          </Typography>

          <ul>
            <li>
              <Typography className="text">
                Request information about how your personal data is processed.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Request a copy of that personal data.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Request that anything inaccurate in your personal data is
                corrected.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Raise an objection about how your personal data is processed.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Request that your personal data is erased if there is no longer
                a justification for it.
              </Typography>
            </li>
            <li>
              <Typography className="text">
                Ask that the processing of your personal data is restricted in
                certain circumstances.
              </Typography>
            </li>
          </ul>
        </div>

        <div className="text-section">
          <Typography className="text">
            <strong>If you have any of these requests, contact us at </strong>
            <a href="mailto:info@manchesterpsychfest.com">
              info@manchesterpsychfest.com
            </a>
          </Typography>
        </div>
      </div>
    </Container>
  );
}

export default PrivacyPolicy;